import React from 'react';
import { string, node } from 'prop-types';

const LabelWithChildren = ({
  label,
  name,
  className,
  labelClassName,
  inputWrapperClassName,
  children,
}) => {
  return (
    <label
      htmlFor={name}
      className={`flex flex-1 flex-col lg:flex-row ${className}`}
    >
      <span className={`label ${labelClassName}`}>{label}</span>
      <div className={`input-form-wrapper ${inputWrapperClassName}`}>
        {children}
      </div>
    </label>
  );
};

LabelWithChildren.propTypes = {
  className: string,
  labelClassName: string,
  inputWrapperClassName: string,
  name: string,
  children: node,
};
LabelWithChildren.defaultProps = {
  className: 'lg:items-center mb-4',
  inputWrapperClassName: '',
  labelClassName: 'pb-1 lg:pb-0 lg:w-4/12',
  label: null,
};

export default LabelWithChildren;
